import { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { Spacing6 } from 'autogen/design-tokens/tokens';
import type { ConnectedContentMenuItemModel } from 'autogen/swagger/all';
import ContentCard from 'components/ContentCard';
import { mapResponsiveImageModelToImageProps } from 'components/generic/Image/helpers/mapToImageProps';
import ListItem from 'components/List/components/ListItem/ListItem';
import QuickViewArticle from 'components/QuickViewArticle/QuickViewArticle';
import { useQuickView } from 'components/quickView';
import type { LinkAction } from 'components/shared/Routing/components/LinkAction/shared/types';
import getUrlFromPageAction from 'components/shared/Routing/components/shared/getUrlFromPageAction';

const paddingOverwrite = css`
    padding-top: ${Spacing6};
    padding-bottom: ${Spacing6};
`;

const StyledActionMenuItem = styled(ListItem.Action)`
    a,
    button {
        ${paddingOverwrite}
    }
`;

const StyledButton = styled(ListItem.Button)`
    button {
        ${paddingOverwrite}
    }
`;

export default function SideMenuArticleItem({ item }: { item: ConnectedContentMenuItemModel }) {
    const { link, heading, text = '', image, isQuickView } = item;
    const linkUrl = link?.pageAction && getUrlFromPageAction(link?.pageAction);
    const { toggle } = useQuickView('inlineConnectedContent');
    const imageProps = useMemo(() => mapResponsiveImageModelToImageProps(image), [image]);

    if (isQuickView && linkUrl) {
        const linkAction = link?.pageAction?.action as LinkAction;

        return (
            <StyledButton>
                {linkUrl && <QuickViewArticle quickViewId="inlineConnectedContent" linkAction={linkAction} />}

                <ContentCard.Horizontal
                    image={imageProps}
                    heading={text}
                    subheading={heading}
                    onClickWrapper={() => {
                        toggle(true);
                    }}
                />
            </StyledButton>
        );
    }

    if (link?.pageAction) {
        return (
            <StyledActionMenuItem action={link.pageAction}>
                <ContentCard.Horizontal
                    image={imageProps}
                    heading={text}
                    subheading={heading}
                    link={{ action: link.pageAction }}
                />
            </StyledActionMenuItem>
        );
    }

    return null;
}
